import React from 'react';
import { StickyContainer } from 'react-sticky';

import Wrapper from '../Wrapper';
import ToolbarContainer from '../../containers/ToolbarContainer';

import Background, { navigation as navBackground, navMsBackground } from '../../routes/Background';
import Lifestyle, { navigation as navLifestyle, navMsLifestyle } from '../../routes/Lifestyle';
import Relapse, { navigation as navRelapse } from '../../routes/Relapse';
import Status, { navigation as navStatus, navPREDSS } from '../../routes/Status';
import QualityOfLife, { navigation as navQualityOfLife, nav15D, navEQ5D } from '../../routes/QualityOfLife';
import Medication, { navMedication, navVitamin } from '../../routes/Medication';
import Benefits, { navigation as navBenefits } from '../../routes/Benefits';
import Rehabilitation, { navigation as navRehabilitation } from '../../routes/Rehabilitation';
import Scores, { navigation as navScores, navFatigue, navMSIS, navMSNQ, navFSMC, navSDMT } from '../../routes/Scores';
import Comorbidity, { navigation as navComorbidity } from '../../routes/Comorbidity';
import Next, { navigation as navNext } from '../../routes/Next';
import Floodlight, { navigation as navFloodlight } from '../../routes/Floodlight';
import Profile, { navigation as navProfile } from '../../routes/Profile';
import OnlineRehabilitation, { navigation as navOnlineRehabilitation } from '../../routes/OnlineRehabilitation';

const DocumentsContainer = () => (
  <StickyContainer>
    <ToolbarContainer
      sections={[
        navBackground,
        navMsBackground,
        navLifestyle,
        navMsLifestyle,
        navRelapse,
        navStatus,
        navPREDSS,
        navQualityOfLife,
        nav15D,
        navEQ5D,
        navMedication,
        navVitamin,
        navBenefits,
        navRehabilitation,
        navScores,
        navSDMT,
        navFatigue,
        navMSIS,
        navMSNQ,
        navFSMC,
        navComorbidity,
        navNext,
        navFloodlight,
        navProfile,
        navOnlineRehabilitation,
      ]}
    />
    <Wrapper>
      <Background />
      <Lifestyle />
      <Relapse />
      <Status />
      <QualityOfLife />
      <Medication />
      <Benefits />
      <Rehabilitation />
      <Scores />
      <Comorbidity />
      <Next />
      <Floodlight />
      <Profile />
      <OnlineRehabilitation />
    </Wrapper>
  </StickyContainer>
);

export default DocumentsContainer;
